import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuthStore } from '@/store/auth.store';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const setRedirectPath = useAuthStore(state => state.setRedirectPath);
  const location = useLocation();

  React.useEffect(() => {
    if (!isAuthenticated) {
      setRedirectPath(location.pathname + location.search);
    }
  }, [location.pathname, location.search, isAuthenticated, setRedirectPath]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
